export const STATUS = {
    CLEARANCE: 'CLEARANCE',
    ERROR: 'ERROR',
    INPUT: 'INPUT',
    KNOCKOUT: 'KNOCKOUT',
    LOADING: 'LOADING',
    QUOTE: 'QUOTE',
    RESULT: 'RESULT',
    SEARCH: 'SEARCH',
    SUCCESS: 'SUCCESS',
    CREATING: 'CREATING',
    DRAFT: 'DRAFT'
};

export const OKTA_VERSIONS = {
    V1: 'v1', // Original version of Okta
    V2: 'v2' // Represents new Okta Identity Engine
}

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
